__turbopack_context__.v({
  "aside": "vMbmqW_aside",
  "main": "vMbmqW_main",
  "order1": "vMbmqW_order1",
  "order1rev": "vMbmqW_order1rev",
  "order2": "vMbmqW_order2",
  "order2rev": "vMbmqW_order2rev",
  "resultsContent": "vMbmqW_resultsContent",
  "zd-article-body": "vMbmqW_zd-article-body",
});
